module.exports = __webpack_public_path__ + "media/images/pos-b17d4cb9a345a68d7c0bdb1efadd32ed.png";